import { readAsDataURL } from "~/components/canvas/easel/prosemirror/plugins/imageDropPlugin";
import { getDocumentDirPath, getPageRelatedFilePath, readBinaryFile } from "~/data/filesystem";
import { LOCAL_WORKSPACE_NAME } from "~/state/types";
import { getGiteaApiUrl } from "~/utils/gitea";

import { createQueryMachine } from "../query.machine";

export const createPageRelatedFileQuery = ({
	workspaceName,
	documentId,
	pageId,
	filename,
}: {
	workspaceName: string;
	documentId: string;
	pageId: string;
	filename: string;
}) =>
	createQueryMachine({
		queryKey: ["related-file", workspaceName, documentId, pageId, filename].join(":"),
		queryFn: async () => {
			if (workspaceName === LOCAL_WORKSPACE_NAME) {
				const documentPath = await getDocumentDirPath(documentId);
				const filePath = await getPageRelatedFilePath(documentPath, pageId, filename);

				const fileContents = await readBinaryFile(filePath);
				if (!fileContents) {
					throw new Error("Failed to read binary file");
				}

				return readAsDataURL(new Uint8Array(fileContents).buffer);
			} else {
				const response = await fetch(
					`${getGiteaApiUrl()}/api/v1/repos/${workspaceName}/${documentId}/raw/pages/${pageId}/related/${encodeURIComponent(filename)}?ref=main`
				);
				if (!response.ok) {
					throw new Error("Failed to fetch public document metadata");
				}

				const documentContents = await response.arrayBuffer();

				return `data:;base64,${documentContents}`;
			}
		},
	});
